import _ from "lodash";
import React from "react";
import requireAuth from "../auth/requireAuth";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import {
  editOrderService,
  fetchOrderService,
  fetchCompanies,
  fetchServiceTypes,
  fetchEquipmentTypes,
} from "../../actions";
import OrderServiceForm from "./OrderServiceForm";

class OrderServiceEdit extends React.Component {
  componentDidMount() {
    this.props.fetchOrderService(this.props.match.params.id);
  }

  onSubmit = (formValues) => {
    if (formValues.file === "") {
      formValues.file = this.props.editOrderService.file;
    }
    this.props.editOrderService(this.props.match.params.id, formValues);
  };

  render() {
    if (!this.props.orderService) {
      return <div className="ui active centered inline loader" />;
    }

    return (
      <div className={"ui container"}>
        <div className={"ui grid"}>
          <div className={"ui row"}>
            <div
              className={
                "ui eight wide left aligned column bottom aligned content"
              }
            >
              <h2>Edição de Ordem de Serviço</h2>
            </div>
            <div
              className={
                "ui four wide right aligned column bottom aligned content"
              }
            >
              <h5>Identificação</h5>
            </div>
            <div
              className={
                "ui four wide right aligned column bottom aligned content"
              }
            >
              <Link
                className={"ui mini icon right labeled button"}
                to={"/order_service/list"}
              >
                <i aria-hidden="true" className="reply icon" /> Voltar
              </Link>
            </div>
          </div>
        </div>
        <div className={"ui divider"} />
        <OrderServiceForm
          initialValues={_.pick(
            this.props.orderService,
            "company.fantasyName",
            "company[@id]",
            "company.document",
            "company.id",
            "title",
            "startDate",
            "endDate",
            "services",            
            "equipments",
            "observation",
            "file",
            "isArchived"
          )}
          onSubmit={this.onSubmit}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    orderService: state.orderServices[ownProps.match.params.id],
  };
};

export default requireAuth(
  connect(mapStateToProps, {
    editOrderService,
    fetchOrderService,
    fetchCompanies,
    fetchServiceTypes,
    fetchEquipmentTypes,
  })(OrderServiceEdit)
);
